import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { spacingValue } from '../utils';

function position(_ref) {
  var position = _ref.position,
      top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left,
      zIndex = _ref.zIndex,
      styles = _objectWithoutPropertiesLoose(_ref, ["position", "top", "right", "bottom", "left", "zIndex"]);

  if (position) {
    styles.position = position;
  }

  if (typeof top !== 'undefined') {
    styles.top = spacingValue(top);
  }

  if (typeof right !== 'undefined') {
    styles.right = spacingValue(right);
  }

  if (typeof bottom !== 'undefined') {
    styles.bottom = spacingValue(bottom);
  }

  if (typeof left !== 'undefined') {
    styles.left = spacingValue(left);
  }

  if (typeof zIndex !== 'undefined') {
    styles.zIndex = zIndex;
  }

  return styles;
}

export default position;